import styled from 'styled-components'
import { Popup } from 'react-map-gl'

const ApartmentTooltip = styled(Popup).attrs({
  closeButton: false,
  tipSize: 0,
  dynamicPosition: true,
})`
  z-index: 1;
  .mapboxgl-popup-content {
    padding: 0px 15px;
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.fontColorWithBackground.white};
  }
`

export default ApartmentTooltip
